import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import toast, { Toaster } from 'react-hot-toast';
import { addBanners, deleteBanner, fetchBanners } from '../../apis/home/banners';
import { Galleria } from 'primereact/galleria';
import { ProgressSpinner } from 'primereact/progressspinner';



const BannersPage = () => {
  const [loading, setLoading] = useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);
  const openDialog = () => setDialogVisible(true);
  const hideDialog = () => {
    setDialogVisible(false);
    setTimeout(() => {
      getBanners();
    }, 1000);
  }
  const [banners, setBanners] = useState([]);

  const getBanners = async () => {
    try {
      setLoading(true);
      const banners = await fetchBanners();
      console.log(banners);

      setBanners(banners);
    } catch (error) {
      // 
      console.log('Error Occurecd in Getting banners');

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const handleDelete = (bannerId, image) => {
    try {
      setLoading(true);

      deleteBanner(bannerId);
      setBanners(prev => prev.filter(b => b.bannerId !== bannerId));
      toast.success('Banner Deleted');
      // setTimeout(() => {
      //   getBanners();
      // }, 1000);
    } catch (error) {
      toast.error('Error: Not Deleted');
      // console.log('error Deleting');
    } finally {
      setLoading(false);
    }
  };

  const itemTemplate = (item) => {

    console.log(item);

    if (!item || !item.image || !item.bannerId) {
      console.warn('Invalid banner item in itemTemplate:', item);
      return null;
    }

    return (<div style={{ position: 'relative' }}>
      <img
        // src={`data:image/jpeg;base64,${item.image}`}
        src={`${item.image}`}
        alt="Banner"
        style={{ width: '500px', height: '400px', objectFit: 'cover', marginRight: '0rem', borderRadius: '8px' }}
      />
      <button
        onClick={() => handleDelete(item.bannerId, item.image)}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          background: 'red',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: 30,
          height: 30,
          cursor: 'pointer'
        }}
      >
        {/* × */}
        <i className="pi pi-trash" style={{ fontSize: '1rem' }}></i>
      </button>
    </div>
    )
  };

  const thumbnailTemplate = (item) => (
    <img
      src={`${item.image}`}
      alt="Banner"
      style={{ width: '80px', height: '70px', objectFit: 'cover', marginRight: '0rem', borderRadius: '8px' }}
    />
  );

  const uploadHandler = async ({ files }) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('images[]', file);
    });

    try {
      setLoading(true);
      await addBanners(formData);
      toast.success('Banner uploaded');
      hideDialog(); // Close dialog and refresh banners
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Upload failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster />
      <h2>App Banners</h2>
      <Button label="Add Banners" icon="pi pi-plus" onClick={openDialog} />
      <Dialog header='Add Banners' visible={dialogVisible} onHide={hideDialog}>
        <div className="flex flex-col gap-3">
          {/* <FileUpload mode="advanced"
            url="http://localhost:2000/banners"
            name="image" accept='image/*' chooseLabel="Select Image" multiple /> */}
          <FileUpload
            customUpload
            uploadHandler={uploadHandler}
            name="image"
            accept="image/*"
            chooseLabel="Select Image"
            multiple
            auto
          />
        </div>
      </Dialog>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {/* {!loading &&
          <Galleria value={banners} item={itemTemplate} thumbnail={thumbnailTemplate} style={{ maxWidth: '640px' }} />
        } */}
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
            <ProgressSpinner />
          </div>
        ) : (
          <Galleria
            key={banners.length}
            value={banners}
            item={itemTemplate}
            thumbnail={thumbnailTemplate}
            style={{ maxWidth: '640px' }}
          />
        )}

      </div>
    </>
  );
};

export default BannersPage;
